/*
 * @Author: yzhao
 * @Date: 2022-04-18 14:25:57
 * @LastEditors: yzhao
 * @LastEditTime: 2022-04-18 14:25:57
 * @Description: file content
 */
let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <actionType>add|update, 必填</actionType>
    <user>
        <userName>用户账号, string (50), 必填</userName>
        <name>用户中文名, string (50), 必填</name>
        <active>是否有效(Y/N; 默认为N), string (50), 必填</active>
        <employeeNumber>用户工号, string (200)</employeeNumber>
        <telephoneNumber>用户手机号, string (200)</telephoneNumber>
    </user>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

export default { xmlRequest, xmlResponse }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.user.synchronize.js